var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"crypto-currency__card",style:(_vm.styleCard)},[_c('div',{ref:"cardBody",staticClass:"crypto-currency__card-body"},[_c('ListHeader'),_c('List',{attrs:{"items":_vm.sortedListToken,"loading":_vm.loading},on:{"update-listener":_vm.resizeCardHeight}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }